import * as css from './SuspendedScreen.css';
import {updateDesignEmail} from '../../../redux/branding/brandingActions';
import {useEffect} from 'react';
import {useContext} from 'react';
import {BrandingContext} from '../context/BrandingContext';
import EmailImage from '../EmailImage';
import {useSelector} from 'react-redux';
import SuspendedDealEditor from '../suspendedDealEditor/SuspendedDealEditor';
import EmailSubjectTextEditor from '../emailSubjectTextEditor/EmailSubjectTextEditor';
import ImageHeader from '../imageHeader/ImageHeader';
import ArrivalConfirmationButtons from '../arrivalConfirmationButtons/ArrivalConfirmationButtons';
import ArrivalConfirmationDetails from '../arrivalConfirmationDetails/ArrivalConfirmationDetails';
import {useBrandingParams} from '../../../hooks/useBrandingParams';

function ArrivalConfirmationScreen() {
    const {textEditor: {setCurrentEditorName}} = useContext(BrandingContext);
    const {currentLang,data,getBrandingData} = useSelector(s => ({
        currentLang:s.branding.currentLang,
        data:s.branding.data,
        getBrandingData:s.branding.getBrandingData
    }));
    const {messageType} = useBrandingParams();
    const {emailContent} = data?.[currentLang]?.[messageType]??{};
    
    const dependencies=[currentLang,getBrandingData[`${currentLang}XHR`]];

    useEffect(() => {
        setCurrentEditorName('emailContent');
    }, []);

    const saveConfirmationText = (content) => {
        updateDesignEmail(messageType, {emailContent: content});
    };
    
    return (   
        <css.container data-cy="ArrivalConfirmationScreen">
            <EmailSubjectTextEditor name={'emailSubject'} dependencies={dependencies}/>
            <ArrivalConfirmationDetails/>
            <ImageHeader text={'imageTextConfirmation'}/>
            <EmailImage eyeName='arrivalImage' name='suspendedImage'/>
            <SuspendedDealEditor defaultText={emailContent} name={'emailSuspendedConfirmationContent'} dependencies={dependencies} onSave={(content)=>{saveConfirmationText(content);}}  lang={currentLang}/>
            <ArrivalConfirmationButtons/>
        
        </css.container>
    );
}

export default ArrivalConfirmationScreen;
